import apiUrlConfig from 'configs/apiUrlConfig';
import AuthenticatedRequestService from 'services/requests/Authenticated';
import * as urlUtils from 'utils/url';

const URLS = {
  INDEX: `${apiUrlConfig.apiEndPoint()}/businesses/:business_id/custom_surveys`,
  CREATE: `${apiUrlConfig.apiEndPoint()}/businesses/:business_id/custom_surveys`,
  SHOW: `${apiUrlConfig.apiEndPoint()}/custom_surveys/:id`,
  UPDATE: `${apiUrlConfig.apiEndPoint()}/custom_surveys/:id`,
  DELETE: `${apiUrlConfig.apiEndPoint()}/custom_surveys/:id`,
  SHOW_PASS: `${apiUrlConfig.apiEndPoint()}/custom_surveys/:id/show_password`,
  VERIFY_PASS: `${apiUrlConfig.apiEndPoint()}/custom_surveys/:id/verify_public_report_password`,
  SURVEY_NAME: `${apiUrlConfig.apiEndPoint()}/custom_surveys/:id/get_survey_name`,
  PUBLIC_REPORT_HEADING: `${apiUrlConfig.apiEndPoint()}/custom_surveys/:id/public_report_heading`,
  SURVEY_PLACARD: `${apiUrlConfig.apiEndPoint()}/custom_surveys/:id/survey_placard`,
};

function insertSurveyIdToUrl(url, id) {
  return url.replace(':id', id);
}

function insertBusinessIdToUrl(url, id) {
  return url.replace(':business_id', id);
}

class SurveyApi {
  /**
   * add new survey within business
   */
  static addNew(
    businessId,
    custom_survey_name,
    address_line_1,
    address_line_2,
    city,
    state,
    zip,
    primary_number,
    is_soono_survey_paused,
    rewards_attributes,
    questions_attributes,
    international,
    custom_terms,
    is_survey_recurring,
    recurring_frequency,
    max_recurring_allowed,
    limit_voucher_per_customer
  ) {
    const CREATE_URL = insertBusinessIdToUrl(URLS.CREATE, businessId);
    const data = {
      custom_survey: {
        name: custom_survey_name,
        address_line_1,
        address_line_2,
        city,
        state,
        zip,
        primary_number,
        is_soono_survey_paused,
        rewards_attributes,
        questions_attributes,
        international,
        custom_terms,
        is_survey_recurring,
        recurring_frequency,
        max_recurring_allowed,
        limit_voucher_per_customer,
      },
    };
    return AuthenticatedRequestService.post(CREATE_URL, data);
  }

  /**
   * gets all surveys within business
   */
  static getAll(businessId) {
    const INDEX_URL = insertBusinessIdToUrl(URLS.INDEX, businessId);
    return AuthenticatedRequestService.get(INDEX_URL);
  }

  /**
   * get survey details
   */
  static getDetails(surveyId) {
    const SHOW_URL = insertSurveyIdToUrl(URLS.SHOW, surveyId);
    return AuthenticatedRequestService.get(SHOW_URL);
  }

  /**
   * updates survey
   */
  static update(
    surveyId,
    custom_survey_name,
    address_line_1,
    address_line_2,
    city,
    state,
    zip,
    primary_number,
    is_soono_survey_paused,
    rewards_attributes,
    international,
    custom_terms,
    default_addon,
    is_survey_recurring,
    recurring_frequency,
    max_recurring_allowed,
    limit_voucher_per_customer
  ) {
    const UPDATE_URL = insertSurveyIdToUrl(URLS.UPDATE, surveyId);

    const data = {
      custom_survey: {
        name: custom_survey_name,
        address_line_1,
        address_line_2,
        city,
        state,
        zip,
        primary_number,
        is_soono_survey_paused,
        rewards_attributes,
        international,
        custom_terms,
        default_addon,
        is_survey_recurring,
        recurring_frequency,
        max_recurring_allowed,
        limit_voucher_per_customer,
      },
    };

    return AuthenticatedRequestService.patch(UPDATE_URL, data);
  }

  /**
   * Update question order
   */

  static updateQuestionOrder(survey_data, question_order, surveyId) {
    const UPDATE_URL = insertSurveyIdToUrl(URLS.UPDATE, surveyId);
    const data = {
      custom_survey: {
        ...survey_data,
        question_order,
      },
    };
    return AuthenticatedRequestService.patch(UPDATE_URL, data);
  }

  static verifyReportPassword(surveyId, pass_query_type, pass = '') {
    const VERIFY_PASS_URL = insertSurveyIdToUrl(URLS.VERIFY_PASS, surveyId);
    return AuthenticatedRequestService.post(
      urlUtils.addQueryParameters(VERIFY_PASS_URL, { pass_query_type, pass })
    );
  }

  static getPassword(surveyId) {
    const SHOW_PASS_URL = insertSurveyIdToUrl(URLS.SHOW_PASS, surveyId);
    return AuthenticatedRequestService.get(SHOW_PASS_URL);
  }

  static saveSurveyReportPassword(surveyId, setPassword, password = null) {
    const INDEX_URL = insertSurveyIdToUrl(URLS.UPDATE, surveyId);

    const data = {
      custom_survey: {
        is_pass_set: setPassword,
        survey_report_password: password,
      },
    };

    return AuthenticatedRequestService.patch(INDEX_URL, data);
  }

  static getSurveyName(surveyId) {
    const SURVEY_NAME_URL = insertSurveyIdToUrl(URLS.SURVEY_NAME, surveyId);
    return AuthenticatedRequestService.get(SURVEY_NAME_URL);
  }

  static publicReportHeading(surveyId) {
    const PUBLIC_REPORT_HEADING_URL = insertSurveyIdToUrl(
      URLS.PUBLIC_REPORT_HEADING,
      surveyId
    );
    return AuthenticatedRequestService.get(PUBLIC_REPORT_HEADING_URL);
  }

  static getSurveyPlacard(surveyId) {
    const SURVEY_PLACARD_URL = insertSurveyIdToUrl(
      URLS.SURVEY_PLACARD,
      surveyId
    );
    return SURVEY_PLACARD_URL;
  }

  /**
   * deletes survey
   */
  static delete(surveyId) {
    const DELETE_URL = insertSurveyIdToUrl(URLS.UPDATE, surveyId);

    const data = {
      is_deleted: true,
    };

    return AuthenticatedRequestService.patch(DELETE_URL, data);
  }
}

export default SurveyApi;



// WEBPACK FOOTER //
// ./src/apis/Survey.js